import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SetActions } from './lead-action.actions';
import { LeadAction } from "../../../models/action.model";


export interface LeadActionModel {
  actions: LeadAction[];
}

@State<LeadActionModel>({
  name: 'LeadActionModel',
  defaults: {
    actions: []
  },
})
@Injectable()
export class LeadActionState {

  private actions;

  @Selector()
  static getActions({ actions }: LeadActionModel): LeadAction[] {
    return actions;
  }

  @Action(SetActions)
  setActions(
    { patchState }: StateContext<LeadActionModel>,
    { actions }: LeadActionModel
  ): void {
    this.actions = patchState({
      actions: actions,
    });
  }

}
